module.exports = __webpack_public_path__ + "media/homepage/header-collage-au-101bdc3f.png";